<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div class="panel">
  <div class="panel-top">
    <button
      cignaButton="link inline no-underline"
      class="toggle-button"
      (click)="toggleCollapsed()"
    >
      Local Auth Toggler
      <cigna-icon
        class="cg-margin-left-sm cg-margin-right-sm"
        [class.icon-collapsed-state]="collapsed === 'y'"
        type="chevron-thin-up"
      ></cigna-icon>
    </button>
  </div>
  <ng-container *ngIf="collapsed === 'n'">
    <div class="cg-margin-top-md">
      <div class="cg-margin-bottom-md" style="font-size: 120%">LOB</div>
      <ng-container *ngIf="appContext === 'chcp'; else evernorthLobs">
        <span
          class="toggle-link"
          style="margin-right: 0.5em"
          [class.toggle-link__active]="lob === LOB_MEDICAL"
          (click)="setUserDevMode(LOB_MEDICAL)"
          >medical</span
        >
        <span
          class="toggle-link"
          style="margin-right: 0.5em"
          [class.toggle-link__active]="lob === LOB_MEDBH"
          (click)="setUserDevMode(LOB_MEDBH)"
          >medbh</span
        >
        <span
          class="toggle-link"
          [class.toggle-link__active]="lob === LOB_DENTAL"
          (click)="setUserDevMode(LOB_DENTAL)"
          >dental</span
        >
        <span
          class="toggle-link"
          [class.toggle-link__active]="lob === LOB_OHP"
          (click)="setUserDevMode(LOB_OHP)"
          >ohp</span
        ></ng-container
      >
      <ng-template #evernorthLobs
        ><span
          class="toggle-link"
          style="margin-right: 0.5em"
          [class.toggle-link__active]="lob === LOB_BEHAVIORAL"
          (click)="setUserDevMode(LOB_BEHAVIORAL)"
          >behavioral</span
        >
        <span
          class="toggle-link"
          [class.toggle-link__active]="lob === LOB_MEDBH"
          (click)="setUserDevMode(LOB_MEDBH)"
          >medbh</span
        ></ng-template
      >
    </div>

    <div class="cg-margin-top-lg">
      <div class="cg-margin-bottom-sm" style="font-size: 120%">
        ENTITLEMENTS
      </div>
      <div *ngFor="let entitlement of allEntitlements">
        <label class="cg-margin-bottom-xs"
          ><input
            #entitlementToggle
            (change)="setUserEntitlements(entitlement, $event.target.checked)"
            type="checkbox"
            [checked]="enabledEntitlements.includes(entitlement)"
          />
          {{ entitlement }}</label
        >
      </div>
    </div>
    <div class="cg-margin-top-lg">
      <div class="cg-margin-bottom-sm" style="font-size: 120%">PERMISSIONS</div>
      <div *ngFor="let permission of allPermissions">
        <label class="cg-margin-bottom-xs"
          ><input
            #permissionToggle
            (change)="setUserPermissions(permission, $event.target.checked)"
            type="checkbox"
            [checked]="enabledPermissions.includes(permission)"
          />
          {{ permission }}</label
        >
      </div>
    </div>
    <div class="cg-margin-top-lg">
      <div class="cg-margin-bottom-sm" style="font-size: 120%">
        IMPERSONATION
      </div>

      <div class="cg-margin-bottom-xs">
        <label
          ><input
            #impersonatorStatus
            (change)="setUserDevImpersonation('')"
            type="radio"
            value=""
            name="impersonatorStatus"
            [checked]="impersonator === ''"
          />
          OFF</label
        >
      </div>
      <div class="cg-margin-bottom-xs">
        <label
          ><input
            #impersonatorStatus
            (change)="setUserDevImpersonation('CHCP_RES')"
            type="radio"
            value="CHCP_RES"
            name="impersonatorStatus"
            [checked]="impersonator === 'CHCP_RES'"
          />
          On - Restricted</label
        >
      </div>
      <div class="cg-margin-bottom-xs">
        <label
          ><input
            #impersonatorStatus
            (change)="setUserDevImpersonation('CHCP_UNRES')"
            type="radio"
            value="CHCP_UNRES"
            name="impersonatorStatus"
            [checked]="impersonator == 'CHCP_UNRES'"
          />
          On - Unrestricted</label
        >
      </div>
    </div>
  </ng-container>
</div>
